<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button defaultHref="/help/messageCenter" data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title data-test="title">Message</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    @if (message) {
        <div class="message-detail">
            <div class="message-header">
                <div class="message-title-row">
                    <ion-icon [name]="getTypeIcon(message)" [color]="getTypeColor(message.type)"
                        class="message-detail-icon"></ion-icon>
                    <h2 data-test="messageTitle">{{message.title}}</h2>
                </div>
                <div class="message-meta">
                    <ion-badge [color]="getTypeColor(message.type)">
                        {{message.type | titlecase}}
                    </ion-badge>
                    @if (message.priority === 'urgent' || message.priority === 'high') {
                        <ion-badge [color]="message.priority === 'urgent' ? 'danger' : 'warning'">
                            {{message.priority | titlecase}} Priority
                        </ion-badge>
                    }
                    <span class="message-date">{{formatDate(message.createdDate)}}</span>
                </div>
            </div>

            <div class="message-body" data-test="messageBody">
                <p style="white-space: pre-line;">{{message.body}}</p>
            </div>

            <div class="message-actions">
                @if (message.actionLabel && message.actionUrl) {
                    <ion-button color="primary" expand="block" (click)="onActionClick()"
                        data-test="messageAction">
                        {{message.actionLabel}}
                    </ion-button>
                }
                <ion-button color="medium" fill="outline" expand="block" (click)="onDismissClick()"
                    data-test="messageDismiss">
                    Dismiss Message
                </ion-button>
            </div>
        </div>
    } @else {
        <div class="message-not-found">
            <ion-icon name="alert-circle-outline" style="font-size: 48px; color: var(--ion-color-medium);"></ion-icon>
            <p>Message not found.</p>
            <ion-button fill="outline" routerLink="/help/messageCenter">
                Back to Message Center
            </ion-button>
        </div>
    }
</ion-content>
